import styled, { createGlobalStyle, css } from 'styled-components';

import {
  background_01_1x1_a,
  background_01_4x3_a,
  background_01_7x2_a,
} from '@xing-com/background-images';
import {
  mediaWideNavless,
  mediaXWide,
  mediaTiny,
  mediaConfined,
} from '@xing-com/layout-tokens';
import {
  cornerRadiusXL,
  scale200,
  scale320,
  scale330,
  xdlColorBackground,
} from '@xing-com/tokens';

import { default as background_04_1x1_a } from './assets/Background_04_1x1_a.svg';
import { default as background_04_7x2_a } from './assets/Background_04_7x2_a.svg';

export const OVERLAP_MOBILE = cornerRadiusXL;
export const OVERLAP_DESKTOP = scale200;
export const OVERLAP_SEARCH_AND_SHUFFLE = scale320;
export const OVERLAP_SEARCH_AND_SHUFFLE_PROMOTIONS_AS_BUTTONS = scale330;

const lightVariables = `
  --headerSearchAndShuffleBackgroundImage: url(${background_01_7x2_a});
  --headerSearchAndShuffleBackgroundImageTiny: url(${background_01_1x1_a});
  --headerBackgroundGradient: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      ${xdlColorBackground} 100%
    );
`;

const darkVariables = `
  --headerSearchAndShuffleBackgroundImage: url(${background_04_7x2_a});
  --headerSearchAndShuffleBackgroundImageTiny: url(${background_04_1x1_a});
  --headerBackgroundGradient: linear-gradient(
    180deg,
    rgba(22, 28, 36, 0) 0%,
    ${xdlColorBackground} 100%
  );
`;

export const BackgroundGlobalStyles = createGlobalStyle`
  :root, :root.light {
    ${lightVariables}
  }
  :root.dark {
    ${darkVariables}
  }
  @media (prefers-color-scheme: dark) {
    :root {
      ${darkVariables}
    }
  }
`;

export const Background = styled.section<{
  $spacious: boolean;
  $isSearchAndShuffle: boolean;
  $showPromotionsAsButtons?: boolean;
}>`
  background-image: url(${background_01_7x2_a});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 15%;
  position: relative;
  overflow: hidden;

  @media ${mediaTiny} {
    background-image: url(${background_01_1x1_a});
    background-position-y: 77%;
  }

  @media ${mediaWideNavless} {
    background-size: 110%;
    background-position-x: 55%;
    padding-bottom: ${OVERLAP_MOBILE};
  }

  @media ${mediaXWide} {
    padding-bottom: ${OVERLAP_DESKTOP};
  }

  ${({ $spacious }) =>
    $spacious &&
    css`
      background-image: url(${background_01_4x3_a});

      @media ${mediaConfined} {
        padding-top: ${scale200};
      }

      @media ${mediaWideNavless} {
        background-image: url(${background_01_7x2_a});
        background-size: cover;
        padding-bottom: 0;
      }
    `};

  ${({ $isSearchAndShuffle, $showPromotionsAsButtons }) =>
    $isSearchAndShuffle &&
    css`
      & {
        padding-bottom: ${$showPromotionsAsButtons
          ? OVERLAP_SEARCH_AND_SHUFFLE_PROMOTIONS_AS_BUTTONS
          : OVERLAP_SEARCH_AND_SHUFFLE};
        background-size: cover;
        background-image: var(--headerSearchAndShuffleBackgroundImage);
      }

      @media ${mediaTiny} {
        background-image: var(--headerSearchAndShuffleBackgroundImageTiny);
        background-position-y: 77%;
      }

      &::after {
        content: '';

        position: absolute;
        width: 100%;
        height: 210px;
        left: 0px;
        bottom: 0px;

        background: var(--headerBackgroundGradient);
      }
    `};
`;
